import { FlowchartPaper_Button_Interface } from "./FlowchartPaper_Button_Interface"

export interface FlowchartPaper_Interface {
    form_id:number,
    makerId:number,
    main_id:number,
    flochart_id:number,
    title:string,
    uniCode:string,
    submitDate: string,
    submitName: string,
    referDate: string,
    flochart_title: string,
    referName: string,
    status: string,
    visible: boolean,
    flowchart_edget:Array<FlowchartPaper_Button_Interface>
}


export function Empty_FlowchartPaper_Interface():FlowchartPaper_Interface{
    return{
        form_id:0,
        makerId:0,
        main_id:0,
        flochart_id:0,
        title:'',
        uniCode:'',
        submitDate: '',
        submitName: '',
        referDate: '',
        referName: '',
        status: '',
        flochart_title: '',
        visible: false,
        flowchart_edget:[]
    }
}